import { render, staticRenderFns } from "./PlatformView.vue?vue&type=template&id=ba2249c2&scoped=true"
import script from "./PlatformView.vue?vue&type=script&lang=js"
export * from "./PlatformView.vue?vue&type=script&lang=js"
import style0 from "./PlatformView.vue?vue&type=style&index=0&id=ba2249c2&prod&scoped=true&lang=css"
import style1 from "./PlatformView.vue?vue&type=style&index=1&id=ba2249c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2249c2",
  null
  
)

export default component.exports